"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];

  if (null != _i) {
    var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;

    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var InlineMenu = function InlineMenu(_ref) {
  var items = _ref.items,
      scrollToTopOffset = _ref.scrollToTopOffset;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      scrollPosition = _useState2[0],
      setSrollPosition = _useState2[1];

  var handleScroll = function handleScroll() {
    var position = window.pageYOffset;
    setSrollPosition(position);
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  if (!items) return null;

  var offset = function offset(el) {
    var rect = el.getBoundingClientRect();
    var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft
    };
  };

  var handleClick = function handleClick(id) {
    var element = document.getElementById(id);
    if (!element) return null;
    window.scrollTo({
      top: offset(element).top - scrollToTopOffset,
      behavior: 'smooth'
    });
  };

  var handleActiveState = function handleActiveState(currentId, nextId, activeByDefault) {
    var element = document.getElementById(currentId);
    var nextElement = document.getElementById(nextId);
    if (!element && activeByDefault) return true;
    if (!element) return null;

    if (!nextElement) {
      return scrollPosition > offset(element).top - (scrollToTopOffset + 10);
    } else {
      return (scrollPosition > offset(element).top - (scrollToTopOffset + 10) || activeByDefault) && scrollPosition < offset(nextElement).top - (scrollToTopOffset + 10);
    }
  };

  return /*#__PURE__*/_react.default.createElement("nav", {
    className: "InlineMenu"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "InlineMenu__nav"
  }, items.map(function (_ref2, index, elements) {
    var menuItemName = _ref2.menuItemName,
        elementId = _ref2.elementId,
        activeByDefault = _ref2.activeByDefault;
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "InlineMenu__nav-item ".concat(handleActiveState(elementId, elements[index + 1] && elements[index + 1].elementId, activeByDefault) && 'is-active'),
      onClick: function onClick() {
        return handleClick(elementId);
      },
      key: elementId
    }, menuItemName || 'missing menuItemName');
  })));
};

InlineMenu.defaultProps = {
  scrollToTopOffset: 0
};
InlineMenu.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    menuItemName: _propTypes.default.string.isRequired,
    elementId: _propTypes.default.string.isRequired,
    activeByDefault: _propTypes.default.bool
  })).isRequired,
  scrollToTopOffset: _propTypes.default.number
};
var _default = InlineMenu;
exports.default = _default;